import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function shelfLifeRangeValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    const parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue) || !/^\d+$/.test(value)) {
      return { notInteger: true };
    }

    if (parsedValue < min || parsedValue > max) {
      return { range: true };
    }

    return null;
  };
}
